import React, { Fragment, useState, useEffect, useContext } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Row, Container, CardBody, Col, Card } from 'reactstrap';
import ReactRouterPropTypes from 'react-router-prop-types';
import PropTypes from 'prop-types';
import { showNotificationAutoDestroy } from '../../shared/components/ShowNotification';
import Modal from '../../shared/components/Modal';
import MatTable from '../../shared/components/material-table';
import GraphQl from '../../GraphQL';
import {
  accountListByFilter,
  removeAccountMutation,
} from '../../shared/queries/Account';
import {
  changeLoadingTrue,
  changeLoadingFalse,
} from '../../redux/actions/loadingActions';
import columns from './components/Columns';
import {
  SMART_BABY_USER,
  ACTION_NAME,
  DEFAULT_PAGE_SIZE,
} from '../../shared/utils/constants';
import SmartContext from '../App/context/SmartContext';

const Account = (props) => {
  const [data, setData] = useState([]);
  const [modal, setModal] = useState(false);
  const [selectedDto, setSelectedDto] = useState({});
  const { t, history, dispatch } = props;
  const context = useContext(SmartContext);

  function showLoading() {
    dispatch(changeLoadingTrue());
  }

  function hideLoading() {
    dispatch(changeLoadingFalse());
  }

  const { loggedUser } = context;

  const loadAllAccount = () => {
    const query = accountListByFilter();
    showLoading();
    GraphQl(query, {})
      .then((res) => {
        res.accountListByFilter = res.accountListByFilter.map((item) => ({
          ...item,
          activeDescription: t(`general.yesno.${item.active}`),
        }));
        setData(res.accountListByFilter);
      })
      .catch(() => {
        showNotificationAutoDestroy(
          'danger',
          t('errors.title'),
          t('errors.error-to-loading')
        );
      })
      .finally(() => {
        hideLoading();
      });
  };

  const toggleModal = () => {
    setModal(!modal);
  };

  const deleteItem = () => {
    toggleModal();
    showLoading();
    const removeMutation = removeAccountMutation(selectedDto.id);
    GraphQl(removeMutation, {})
      .then(() => {
        showNotificationAutoDestroy(
          'success',
          t('success.title'),
          t('success.successfully-removed')
        );
      })
      .finally(() => {
        loadAllAccount();
        hideLoading();
      });
  };

  const addItemClickHandler = () => {
    setSelectedDto({ active: true, id: 0 });
    history.push('/minime/conta/mnt/0');
  };

  const removeItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    toggleModal();
  };

  const editItemClickHandler = (evt, rowData) => {
    setSelectedDto({ ...rowData });
    history.push(`/minime/conta/mnt/${rowData.id}`);
  };

  const actionsDisabledByConditional = (propss) => {
    if (propss.actions && propss.actions.length) {
      const copyProps = { ...propss };
      copyProps.actions.find((a) => a.name === ACTION_NAME.REMOVE).hidden =
        copyProps.data.smartpay;
      copyProps.actions.find((a) => a.name === ACTION_NAME.EDIT).hidden =
        loggedUser.login.toUpperCase() !== SMART_BABY_USER &&
        copyProps.data.smartpay;
    }
  };

  useEffect(() => {
    loadAllAccount();
  }, []);

  return (
    <Fragment>
      <Modal
        color="warning"
        title={t('notifications.attention')}
        btn="Warning"
        message={t('notifications.delete_modal')}
        toggle={toggleModal}
        modal={modal}
        onConfirm={deleteItem}
      />
      <Container>
        <Row className="Table">
          <Col md={12} lg={12}>
            <Card>
              <CardBody className="material-table-card">
                <div className="material-table__wrap">
                  <MatTable
                    data={data}
                    columns={columns(t)}
                    deleteAction={toggleModal}
                    onAddClick={addItemClickHandler}
                    onEditClick={editItemClickHandler}
                    onRemoveClick={removeItemClickHandler}
                    onRefreshClick={loadAllAccount}
                    title={t('panels.conta')}
                    pageSize={DEFAULT_PAGE_SIZE}
                    actionsDisabled
                    actionsDisabledByConditional={actionsDisabledByConditional}
                  />
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

Account.propTypes = {
  t: PropTypes.func.isRequired,
  history: ReactRouterPropTypes.history.isRequired,
  dispatch: PropTypes.func.isRequired,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(Account)
);
